module.exports = __webpack_public_path__ + "static/media/arrow-insta.b8a665a3.svg";